import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { ContentBlock } from '../../pages/components';
import Button from '../../../ui/button/Button';

class TotalSalesBlockAdmin extends Component {
  renderHeaderActions = () => {
    return (
      <NavLink to="/admin/transactions/export">
        <Button>Tulosta myyntihistoria</Button>
      </NavLink>
    );
  }

  render() {
    return (
      <ContentBlock
        title="Kokonaismyyntitilanne"
        renderActions={this.renderHeaderActions}
      />
    );
  }
};

export default TotalSalesBlockAdmin;


// WEBPACK FOOTER //
// ./src/modules/transaction/components/TotalSalesBlockAdmin.js